import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item4DescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item4Description: React.FC<Item4DescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [item4, set_item4] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #4']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #4': [v, b.values?.['Expand Primary Structure']?.['Item #4']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={item4}
                />
            ) : (
                <TextBox
                    value={item4}
                    onChange={(value) => set_item4(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
